import styled from "styled-components";

import { MovieInformationStyledProps as Props } from "./MovieInformation.types";

const MovieInformationStyled = styled.div<Props>`
  .MovieInformation {
    &__section {
      padding-bottom: 2.4rem;
    }

    &__title {
      font-size: 2.4rem;
      line-height: 4rem;
      padding-top: 2.4rem;
      padding-bottom: 1.6rem;
      color: var(--palette-light-blue-s10-l60);
    }

    &__detail {
      font-size: 1.4rem;
      color: var(--palette-white);
    }

    &__row {
      display: flex;
      flex-wrap: wrap;
    }

    &__chip {
      background-color: var(--palette-gray-s0-l30-a40);
      border-radius: 0.6rem;
      padding: 0.4rem 0.8rem;
      margin-right: 0.8rem;
      margin-bottom: 0.8rem;

      &__text {
        color: var(--palette-white);
      }
    }

    &__actor {
      display: flex;
      flex-direction: column;
      align-items: center;
      flex-basis: 25%;
      flex-shrink: 0;
      padding-bottom: 1.6rem;

      &__image {
        width: 4.4rem;
        height: 4.4rem;
        border-radius: 50%;
        object-fit: cover;
        margin-bottom: 0.8rem;
      }

      &__name {
        color: var(--palette-white);
        text-align: start;
      }
    }

    &__circle {
      background: linear-gradient(
        270deg,
        var(--palette-purple-s85-l45) -16%,
        var(--palette-pink-s75-l65) 48%,
        var(--palette-blue-s100-l45) 112%
      );
      border-radius: 50%;
      width: 4.8rem;
      height: 4.8rem;
      margin-bottom: 0.8rem;
    }

    &__box {
      background: var(--palette-mid-blue-s15-l20);
      width: 4.4rem;
      height: 4.4rem;
      border-radius: 50%;
      margin-left: 0.2rem;
      margin-top: 0.2rem;

      &:before {
        content: attr(data-letters);
        display: flex;
        font-size: 1.6rem;
        text-align: center;
        border-radius: 50%;
        vertical-align: middle;
        color: white;
        justify-content: center;
        padding-top: 1.2rem;
      }
    }

    &__see-all {
      font-weight: 700;
      color: var(--palette-primary);
      font-size: 1.6rem;
    }
  }
`;

export default MovieInformationStyled;
